import { Injectable } from '@angular/core';
import Mousetrap from 'mousetrap';

@Injectable({
  providedIn: 'root'
})
export class MousetrapWrapperService {
  bind(keyCombo, wrappedCallback, element?) {
    return Mousetrap(element).bind(keyCombo, wrappedCallback);
  }
}
